import React from "react";
import Image from "../../assets/images/christmas.jpg";

const PlanCard = ({ testimonial, onAdd }) => {
  return (
    <div className="flex flex-col min-w-[150px] overflow-hidden">
      <img
        src={testimonial?.testomonial_rec_tumbnailUrl ??Image}
        alt={testimonial.testimonial_name}
        className="w-full h-[100px] object-cover rounded-lg"
      />

      <div className="p-2 flex flex-col flex-1">
        <h3 className="text-sm font-semibold text-white truncate">
          {testimonial.testimonial_name}
        </h3>

        <button
          onClick={() => {
                        onAdd && onAdd();
          }}
          className="mt-2 w-[80%] bg-white text-black text-xs font-semibold py-1 rounded-[50px]"
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default PlanCard;
